import { isActionCurrent } from '@/_core/fluxstore/dispatchOwnership';
import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class FlashJustDragged extends Action<StorymapState> {
    public static ACTION_TYPE = 'FlashJustDragged';

    public constructor() {
        super(FlashJustDragged.ACTION_TYPE);
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const reducer = (state: StorymapState, action: FlashJustDragged): void => {
    state.justDraged = true;
    setTimeout(() => {
        if (isActionCurrent(action)) state.justDraged = false;
    }, 500);
};

//@ts-ignore
registerReducer(FlashJustDragged.ACTION_TYPE, reducer);
